export default "<app-layout *ngIf=\"currentUser && publisher\"></app-layout>\n";